import { PubSub } from "@/shared/utils/pubSub";

type PlaceSelectionCallback = (fieldPath: string, gpid: string) => void;

/**
 * Neutral pub-sub channel for place selection events.
 *
 * `PlaceAutocompleteField` publishes when a place is genuinely selected — a click,
 * or an inferred match that actually changed the field's gpid. It never publishes
 * on text edits (that would clear the exactness scope, see design-rationale.md
 * "Exactness outlives gpid") and never on clears.
 *
 * `PlaceExactness` subscribes, filtered to its own `fieldPath`, and applies the
 * level-based default. The event, not `gpid` state, is what distinguishes a genuine
 * user selection from a programmatic write of the same value.
 */
export const placeSelectionPubSub = new PubSub<PlaceSelectionCallback>();
